// app/components/CustomLayout/ImageBanner.tsx
import Image from "next/image";

export default function ImageBanner({ src }: { src: string }) {
  return (
    <div className="relative w-full h-[50vh] overflow-hidden">
      <Image
        src={src}
        alt="Banner"
        fill
        sizes="100vw"
        className="object-cover"
        priority
      />
      {/* Overlay gradiente para mejor legibilidad */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/10 to-black/40"></div>

      {/* Efecto de ruido sutil para profundidad */}
      <div className="absolute inset-0 bg-[url('/noise.png')] opacity-5 mix-blend-overlay"></div>
    </div>
  );
}
